import { Translations } from './translations'

export const it: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'AI Training Tycoon',
  settings: 'Impostazioni',

  // Resources
  resources: 'Risorse',
  money: 'Denaro',
  energy: 'Energia',
  compute: 'Elaborazione',
  quality: 'Qualità',
  totalUsers: 'Utenti totali',
  price: 'Prezzo',
  research: 'Ricerca',

  // Actions
  train: 'Allena',
  trainCost: 'Costo',
  qualityGain: 'qualità',
  inference: 'Inferenza',
  needUsers: 'Utenti necessari!',
  usersWaiting: 'utenti in attesa',
  qualityToAttract: 'Qualità > 40% per attirare',
  researchAction: 'Ricerca',
  unlocksAfter: 'Si sblocca dopo',
  computeSpent: 'elaborazione spesa',
  cost: 'Costo',
  compShort: 'elab',
  energyShort: 'ener',

  // Hardware
  hardware: 'Hardware',
  computePerSec: 'elaborazione/s',
  usesEnergy: 'utilizza',
  devicesTotal: 'dispositivi totali',

  // Models
  training: 'Allenamento',
  yourModels: 'I tuoi modelli',
  params: 'parametri',
  maxUsers: 'Utenti max',
  trainCost2: 'Costo allenamento',
  unlocked: 'sbloccato',
  researchPoints: 'ricerca',

  // Upgrades
  upgrades: 'Potenziamenti',
  upgradesLockedMsg: 'Allena il tuo modello al 50% di qualità per sbloccare i potenziamenti',
  max: 'MAX',
  all: 'Tutto',
  
  // Upgrade tiers
  tierGarage: 'Garage',
  tierGarageDesc: 'L\'inizio',
  tierStartup: 'Startup',
  tierStartupDesc: 'Era GPT-1',
  tierScaleUp: 'Scalabilità',
  tierScaleUpDesc: 'Era GPT-2/3',
  tierEnterprise: 'Enterprise',
  tierEnterpriseDesc: 'Era ChatGPT',
  tierHyperscale: 'Iperschala',
  tierHyperscaleDesc: 'Era GPT-4',
  tierGlobal: 'Globale',
  tierGlobalDesc: 'Era della concorrenza',
  tierSuperintelligence: 'Superintelligenza',
  tierSuperintelligenceDesc: 'Era GPT-5+',
  tierSingularity: 'Singolarità',
  tierSingularityDesc: 'Era AGI/ASI',

  // Footer
  computeSpentStat: 'Elaborazione spesa',
  time: 'Tempo',
  resetGame: 'Resetta gioco',
  resetConfirm: 'Sei sicuro di voler resettare tutto il progresso?',
  pause: 'Pausa',
  resume: 'Riprendi',

  // Event Log
  eventLog: 'Registro eventi',
  welcome: 'Benvenuto in GPT Clicker! Allena il tuo modello per iniziare.',

  // Price
  market: 'Mercato',
  pricePerMillion: '$/1M token',

  // Tags
  tagEnergy: 'ENER',
  tagCompute: 'ELAB',
  tagHw: 'HW',
  tagTrain: 'ALLEN',
  tagResearch: 'RIC',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Anno 2020. Hai un\'idea: allena un piccolo modello linguistico basato sull\'architettura transformer.',
  tutorialFirstTrain: 'Allenamento iniziato! Il tuo laptop converte l\'energia in elaborazione. Ogni allenamento migliora la qualità del modello.',
  tutorialQuality20: 'Il modello sta imparando i pattern di base. Continua ad allenare per migliorare la qualità.',
  tutorialQuality40: 'Qualità sopra il 40%! Il tuo modello può ora generare testo abbastanza coerente. Gli utenti stanno iniziando a notare...',
  tutorialQuality50: 'Potenziamenti sbloccati! Usa i tuoi guadagni per acquistare hardware migliore e espandere la tua capacità energetica.',
  tutorialFirstUsers: 'I tuoi primi utenti! Fai clic su INFERENZA per gestire le loro richieste e guadagnare denaro.',
  tutorialUsers10: 'La voce si diffonde. Più utenti stanno provando il tuo modello. Considera di aumentare il prezzo...',
  tutorialMoney100: 'Hai $100! È ora di aggiornare il tuo hardware. GPU migliori = più elaborazione = allenamento più veloce.',
  tutorialMoney1k: 'Il tuo piccolo progetto AI sta diventando un vero business. Gli investitori stanno iniziando a chiamare...',
  tutorialResearchUnlock: 'RICERCA sbloccata! Spendi elaborazione nella ricerca per sbloccare modelli più grandi e potenti.',
  tutorialFirstResearch: 'I punti ricerca si accumulano. Quando ne avrai abbastanza, potrai sbloccare la prossima architettura del modello.',
  tutorialGpt2Small: 'GPT-2 Small sbloccato! Questa architettura può gestire compiti più complessi. Allenala da zero.',
  tutorialGpt2Large: 'GPT-2 Large! Dicono che potrebbe essere "troppo pericolosa da rilasciare"...',
  tutorialGpt3: 'Inizia l\'era di GPT-3. Il few-shot learning cambia tutto. Il mondo sta guardando.',
  tutorialGpt4: 'GPT-4 è qui. Multimodale, ragionamento e strangamente capace. La corsa all\'IA si intensifica.',
  tutorialAgi: 'L\'hai fatto. L\'AGI è qui. Capisce. Si migliora da sola. Quello che succede dopo dipende da te...',
  tutorialHwGaming: 'Bella GPU! L\'allenamento è molto più veloce adesso. I tuoi vicini potrebbero lamentarsi della bolletta della luce.',
  tutorialHwServer: 'Un vero server rack! Sei andato oltre il garage. È ora di affittare uno spazio ufficio.',
  tutorialHwDatacenter: 'Il tuo proprio data center! Ora stai competendo con le grandi aziende tecnologiche.',
  tutorialHwSatellite: 'Elaborazione orbitale! La costellazione Moonlink fornisce una potenza di elaborazione senza precedenti dallo spazio.',
  tutorialHwQuantum: 'Supremazia quantistica raggiunta. Il QC-1024 opera su principi che renderebbero nervoso Einstein.',
  tutorialUsers100: '100 utenti! Stai guadagnando trazione. I blog tecnologici stanno scrivendo di te.',
  tutorialUsers1k: '1.000 utenti! Hai bisogno di assumere un team di supporto. E forse alcuni avvocati.',
  tutorialUsers100k: '100K utenti! Sei una startup unicorno ora. I VC stanno litigando per darti soldi.',
  tutorialUsers1m: 'UN MILIONE DI UTENTI! Stai cambiando il modo in cui l\'umanità interagisce con la tecnologia.',

  // Model descriptions
   modelTinyDesc: 'Un umile inizio. Appena coerente, ma funziona.',
   modelGpt2SmallDesc: 'Il modello che ha avviato tutto. Davvero utile.',
   modelGpt2LargeDesc: 'Troppo pericoloso da rilasciare... o no?',
   modelGpt3Desc: 'Few-shot learning. Il mondo lo nota.',
   modelGpt4Desc: 'Multimodale. Ragionamento. Inizia la corsa agli armamenti.',
   modelAgiDesc: 'Capisce. Si migliora da sola. E adesso?',

   // Model descriptions (new keys for all models)
   modelTransformerDesc: 'Un umile inizio. L\'architettura Transformer è nata.',
   modelGpt1Desc: 'Pre-addestramento generativo. I modelli di linguaggio possono imparare!',
   modelGpt2Desc: 'Troppo pericoloso da rilasciare... o no?',
   modelGpt35Desc: 'Magia RLHF. ChatGPT diventa virale dall\'oggi al domani.',
   modelGpt41Desc: 'Più veloce, più economico, migliore. Il gioco dell\'iterazione.',
   modelU1Desc: 'Appare un competitor selvaggio. Progressi nel ragionamento.',
   model2UDesc: 'Il seguito. Chain-of-thought su steroidi.',
   modelGpt5Desc: 'Ragionamento a livello di dottorato. Gli scienziati sono nervosi.',
   modelGpt6Desc: 'Scrive codice migliore della maggior parte degli ingegneri. Tutti i modelli precedenti interrotti.',
   modelGpt7Desc: 'Competenza generale artificiale raggiunta.',
   modelAgi1Desc: 'Capisce. Impara. Si migliora da sola.',
   modelAgi2Desc: 'Auto-miglioramento ricorsivo. La singolarità si avvicina.',
   modelAgi3Desc: 'L\'ultima iterazione AGI. Preparazione alla trascendenza.',
   modelAsiDesc: 'Superintelligenza Artificiale. La Singolarità è qui.',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Overclock laptop',
  upgradeLaptopOverclockDesc: 'Spinge il tuo laptop più forte: +2 elaborazione/s',
  upgradeBetterOutlet: 'Presa migliore',
  upgradeBetterOutletDesc: '+50 energia max',
  upgradeSolarPanel: 'Pannello solare',
  upgradeSolarPanelDesc: '+1 energia/s rigenrazione',
  upgradePowerGrid: 'Connessione rete elettrica',
  upgradePowerGridDesc: '+5 energia/s rigenrazione',
  upgradeNuclearPlant: 'Centrale nucleare',
  upgradeNuclearPlantDesc: '+20 energia/s rigenrazione',
  upgradeFusionReactor: 'Reattore a fusione',
  upgradeFusionReactorDesc: '+100 energia/s rigenrazione',
  upgradeDysonSphere: 'Sfera di Dyson',
  upgradeDysonSphereDesc: '+1000 energia/s rigenrazione',
  upgradeRamUpgrade: 'Aggiornamento RAM',
  upgradeRamUpgradeDesc: '+50 elaborazione max',
  upgradeSsdArray: 'Array SSD',
  upgradeSsdArrayDesc: '+200 elaborazione max',
  upgradeBetterOptimizer: 'Ottimizzatore migliore',
  upgradeBetterOptimizerDesc: '+20% efficienza allenamento',
  upgradeResearchPapers: 'Articoli di ricerca',
  upgradeResearchPapersDesc: '+20% efficienza ricerca',
  upgradeSelfServicePortal: 'Portale self-service',
  upgradeSelfServicePortalDesc: 'Gli utenti si aiutano da soli: 0.5 auto-inferenza/s',
  upgradeApiAccess: 'Accesso API',
  upgradeApiAccessDesc: 'Gli sviluppatori integrano il tuo modello: +1 auto-inferenza/s',
  upgradeMobileApp: 'Applicazione mobile',
  upgradeMobileAppDesc: 'Utenti in movimento: +2 auto-inferenza/s',
  upgradeEnterpriseTier: 'Livello Enterprise',
  upgradeEnterpriseTierDesc: 'Grandi clienti, grande volume: +5 auto-inferenza/s',
  upgradeGlobalCdn: 'CDN globale',
  upgradeGlobalCdnDesc: 'Bassa latenza globale: +10 auto-inferenza/s',
  upgradeBasicChatbot: 'Chatbot di base',
  upgradeBasicChatbotDesc: 'Un semplice widget web: +0.2 auto-inferenza/s',
  upgradeBulkApi: 'API in blocco',
  upgradeBulkApiDesc: 'Elaborazione batch ad alto volume: +3 auto-inferenza/s',
  upgradeNeuralEdge: 'Rete Neural Edge',
  upgradeNeuralEdgeDesc: 'IA al bordo: +20 auto-inferenza/s',
  upgradeQuantumInference: 'Inferenza quantistica',
  upgradeQuantumInferenceDesc: 'Inferenza accelerata quanticamente: +50 auto-inferenza/s',
  upgradeOmnipresentAi: 'IA onnipresente',
  upgradeOmnipresentAiDesc: 'IA ovunque, tutto in una volta: +100 auto-inferenza/s',
  upgradeTrainingScheduler: 'Schedulatore allenamento',
  upgradeTrainingSchedulerDesc: 'Allenamenti automatici: +0.1 auto-allenamento/s',
  upgradeTrainingPipeline: 'Pipeline allenamento',
  upgradeTrainingPipelineDesc: 'Allenamento continuo: +0.2 auto-allenamento/s',
  upgradeMlOpsPlatform: 'Piattaforma MLOps',
  upgradeMlOpsPlatformDesc: 'Automazione completa: +0.5 auto-allenamento/s',
  upgradeNeuralArchitectureSearch: 'Ricerca architettura neurale',
  upgradeNeuralArchitectureSearchDesc: 'IA allena IA: +1 auto-allenamento/s',
  upgradeSelfImprovingTraining: 'Allenamento auto-migliorante',
  upgradeSelfImprovingTrainingDesc: 'Miglioramento ricorsivo: +2 auto-allenamento/s',
  upgradeResearchIntern: 'Stagista ricerca',
  upgradeResearchInternDesc: 'Aiuto entry-level: +0.1 auto-ricerca/s',
  upgradeResearchTeam: 'Team ricerca',
  upgradeResearchTeamDesc: 'Ricercatori dedicati: +0.2 auto-ricerca/s',
  upgradeResearchDivision: 'Divisione ricerca',
  upgradeResearchDivisionDesc: 'Dipartimento completo: +0.5 auto-ricerca/s',
  upgradeAiResearchLab: 'Laboratorio ricerca IA',
  upgradeAiResearchLabDesc: 'Scoperta assistita da IA: +1 auto-ricerca/s',
  upgradeAutonomousResearch: 'Ricerca autonoma',
  upgradeAutonomousResearchDesc: 'L\'IA conduce la ricerca: +2 auto-ricerca/s',
  upgradeAntimatterReactor: 'Reattore antimateria',
  upgradeAntimatterReactorDesc: '+10000 energia/s rigenrazione',
  upgradePhDScientists: 'Scienziati PhD',
  upgradePhDScientistsDesc: 'Assumi il miglior talento: +200% efficienza ricerca',
  upgradeResearchLab: 'Laboratorio ricerca',
  upgradeResearchLabDesc: 'Struttura dedicata: +500% efficienza ricerca',
  upgradeAiResearchAssistant: 'Assistente ricerca IA',
  upgradeAiResearchAssistantDesc: 'GPT-4 aiuta nella ricerca: +1000% efficienza ricerca',
  upgradeAiScientist: 'Scienziato IA',
  upgradeAiScientistDesc: 'IA conduce esperimenti autonomamente: +2000% efficienza ricerca',
  upgradeResearchSwarm: 'Sciame ricerca IA',
  upgradeResearchSwarmDesc: 'Migliaia di ricercatori IA: +5000% efficienza ricerca',
  upgradeRecursiveResearch: 'Auto-miglioramento ricorsivo',
  upgradeRecursiveResearchDesc: 'IA migliora IA: +10000% efficienza ricerca',
  upgradeSingularityResearch: 'Ricerca singolarità',
  upgradeSingularityResearchDesc: 'Oltre la comprensione: +50000% efficienza ricerca',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: 'GPU usata: +3 calcolo/sec',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: 'GPU gaming: +8 calcolo/sec',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: 'GPU professionale: +20 calcolo/sec',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: 'Workstation: +50 calcolo/sec',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: 'Rack server (4x A100): +120 calcolo/sec',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'Cluster GPU (8x H100): +300 calcolo/sec',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: 'Datacenter edge: +800 calcolo/sec',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: 'Datacenter: +2K calcolo/sec',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: 'Mega datacenter: +5K calcolo/sec',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: 'Rete globale: +15K calcolo/sec',
  upgradeHwSupercomputer: 'Frontier X1 Supercomputer',
  upgradeHwSupercomputerDesc: 'Supercomputer: +50K calcolo/sec',
  upgradeHwSatellite: 'SkyNet Moonlink Costellazione',
  upgradeHwSatelliteDesc: 'Satelliti orbitali: +200K calcolo/sec',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: 'Computer quantistico: +1M calcolo/sec',
  upgradeHwDysonCompute: 'Sfera di Calcolo Dyson',
  upgradeHwDysonComputeDesc: 'Calcolo su scala stellare: +10M calcolo/sec',
  upgradeHwMatrioshka: 'Cervello Matrioska',
  upgradeHwMatrioshkaDesc: 'Calcolo su scala galattica: +100M calcolo/sec',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: 'GPU usata: +3 elaborazione/s',
  hwGamingGpuDesc: 'GPU gaming: +8 elaborazione/s',
  hwProGpuDesc: 'GPU Pro: +20 elaborazione/s',
  hwWorkstationDesc: 'Workstation: +50 elaborazione/s',
  hwServerRackDesc: 'Server rack (4x A100): +120 elaborazione/s',
  hwGpuClusterDesc: 'Cluster GPU (8x H100): +300 elaborazione/s',
  hwMiniDatacenterDesc: 'Data center edge: +800 elaborazione/s',
  hwDatacenterDesc: 'Data center: +2K elaborazione/s',
  hwMegaDatacenterDesc: 'Mega data center: +5K elaborazione/s',
  hwDatacenterNetworkDesc: 'Rete globale: +15K elaborazione/s',
   hwSupercomputerDesc: 'Supercomputer: +50K elaborazione/s',
   hwSatelliteDesc: 'Satelliti orbitali: +200K elaborazione/s',
   hwQuantumDesc: 'Computer quantico: +1M elaborazione/s',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: 'Acquistato',
  switchedTo: 'Passato all\'allenamento',
  unlockedModel: 'Sbloccato',
  scalesToUsers: 'Scala fino a',
  trainItToAttract: 'utenti. Allenalo per attirare gli utenti!',
  unlimited: 'illimitato',
  language: 'Lingua',
  
  // Mobile labels
  mobileResources: 'Risorse',
  mobileModels: 'Modelli',
  mobileHardware: 'Hardware',
  mobileUpgrades: 'Potenziamenti',
  sell: 'Vendi',
  sellFor: 'Vendi per',
  discontinueConfirm: 'Interrompere {model}? Gli utenti migreranno verso altri modelli.',
  autoInference: 'Auto-inferenza',
  autoInferenceRate: 'Auto Inferenza',
  autoTrain: 'Auto-allenamento',
  autoTrainRate: 'Auto Allenamento',
  autoResearch: 'Auto-ricerca',
  autoResearchRate: 'Auto Ricerca',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Allena modelli IA, servi utenti, costruisci il tuo impero IA!',
  tooltipMoney: 'Denaro - Guadagnato dalle inferenze degli utenti. Usa per acquistare potenziamenti e hardware.',
  tooltipEnergy: 'Energia - Si rigenera nel tempo. Alimenta il tuo hardware per generare elaborazione.',
  tooltipCompute: 'Elaborazione - Generata dall\'hardware. Usata per allenamento, inferenza e ricerca.',
  tooltipResearch: 'Punti ricerca - Spendi elaborazione per guadagnare PR. Usa PR per sbloccare nuovi modelli IA.',
  tooltipUsers: 'Utenti - Attratti dalla qualità del modello. Più utenti = più ricavi per inferenza.',
  tooltipComputeSpent: 'Elaborazione totale spesa - Elaborazione totale usata per allenamento e ricerca.',
  tooltipPlayTime: 'Tempo di gioco - Quanto tempo hai speso a costruire il tuo impero IA.',
  tooltipSettings: 'Impostazioni - Opzioni debug, resetta gioco',

  // Share
  shareButton: 'Condividi',
  shareText: 'Sto costruendo un impero IA in GPT Clicker! {users} utenti, {money} ricavi, allenando {model}. Riesci a battere il mio {time}?',
  shareCopied: 'Testo copiato!',
  imageCopied: 'Immagine copiata!',
  shareChallenge: 'Riesci a battermi?',
  shareTitle: 'Condividi il tuo progresso',
  shareDownload: 'Salva immagine',
  model: 'Modello',

  // Feedback
  feedback: 'Feedback',
  feedbackTitle: 'Invia feedback',
  feedbackPlaceholder: 'Dimmi cosa pensi di GPT Clicker...',
  feedbackEmailPlaceholder: 'Email (opzionale)',
  feedbackSend: 'Invia',
  feedbackSending: 'Invio...',
  feedbackSuccess: 'Grazie per il tuo feedback!',
  feedbackError: 'Errore nell\'invio del feedback. Riprova.',
  feedbackRateLimit: 'Troppi richieste. Aspetta prima di inviare altro feedback.',
  feedbackClose: 'Chiudi',

  // Console messages
  consoleGameLoaded: 'Gioco caricato dal salvataggio',
  consoleGameSaved: 'Gioco salvato',
  consoleFailedToSave: 'Errore nel salvataggio del gioco:',
  consoleFailedToLoad: 'Errore nel caricamento del gioco:',
  consoleFailedToClear: 'Errore nella cancellazione del salvataggio:',

  // Victory
  victoryTitle: 'Congratulazioni!',
  victorySubtitle: 'La civiltà umana ha raggiunto la Singolarità',
  victoryTime: 'Tempo alla Singolarità',
  victoryCta: 'Dovremmo costruire Singularity Clicker? Lascia un commento sui social media!',
  victoryClose: 'Continua a giocare',
}
